<template>
  <div class="page" >
    <router-view></router-view>
    <FooterNav v-show="loginInfo" />
    <LoginPanel v-show="$route.name == 'position'"/>
  </div>
</template>

<script>
import FooterNav from "../components/FooterNav";
import { mapState, mapMutations } from "vuex";
import LoginPanel from "@/components/LoginPanel.vue";
export default {
  name: "index",
  components: {
    FooterNav,
    LoginPanel,
  },

  data() {
    return {
      showBtn: true,
    };
  },
  computed: {
    ...mapState("index", ["loginInfo"]),
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    ...mapMutations("index", ["setStateItem"]),
  },
};
</script>
<style lang='scss' scoped>
.page {
  overflow: hidden;
  height: 100%;
  background: #fbfbfb;
  display: flex;
  flex-direction: column;
}
.login_card {
  width: 100%;
  padding: 21px 40px 45px;
  background-color: white;
  box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 0px 0px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  .login_desc {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5d5d5d;
    text-align: center;
  }
  .login_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #5ebfb9;

    color: white;
    height: 50px;
    border: none;
    border-radius: 5px;
    margin: 0.61rem 0 0.29rem;

    font-size: 18px;
    font-weight: 500;
    width: 100%;
  }
}
</style>
